import React, { useContext, useEffect } from 'react';
import SEO from '~/components/seo';
import BlogItemDetail from '~/components/blog/blogItemDetail';
import BlogItemNotExists from '~/components/blog/blogItemNotExists';
import { getBlogOgImage } from '~/components/blog/blogImages';
import Layout from '~/components/layout/_layout';
import { LangContext } from '~/providers/LangProvider';
import { useRouter } from 'next/router';
import Countries from '~/components/countries_enum.ts';
import { countryCodesBlog } from '~/providers/LangProvider/langUtils';
import PAGE_TYPES from "../../page_types";

const Article = ({ articleLocales, country }) => {
    const ctxLang = useContext(LangContext);

    const parsedArticles = JSON.parse(articleLocales);
    let articleData = parsedArticles[ctxLang.state.lang];

    let articleNotExists = articleData == [] || articleData == null;
    const router = useRouter();

    useEffect(() => {
        if (articleData) {
            let shouldBePath = `/${ctxLang.state.lang}/${countryCodesBlog[country]}/blog/${articleData.slug}`;
            if (window.location.pathname !== shouldBePath) {
                window.history.replaceState('', '', shouldBePath);
            }
        }
    }, [ctxLang.state.lang]);

    if (articleNotExists) {
        return (
            <Layout country={country} business>
                <SEO title="blog.notFound.title" />
                <BlogItemNotExists country={country} />
            </Layout>
        );
    }
    return (
        <Layout country={country} page={PAGE_TYPES.BLOG} business>
            <SEO
                title={articleData.title}
                ogImage={getBlogOgImage(articleData.og_image.src)}
                description={articleData.metaDescription}
            />
            <BlogItemDetail article={articleData} country={country} />
        </Layout>
    );
};

export default Article;
